import { type ReduxUser } from 'models';

export const canCreateTags = ({ viewer, organizationId }: { viewer: ReduxUser; organizationId?: string }) =>
  viewer.superadmin || Boolean(organizationId && viewer.admin_organizations.includes(organizationId));
